<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加运费</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="类型" width="100" align="center">
            <template slot-scope="scope">
              <span :style="scope.row.type == 1 ? 'color:#1989fa' : 'color:#f56c6c'">
                {{ scope.row.type == 1 ? "普通" : "指定区域" }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="区域名称" prop="area_name" min-width="150" />
          <el-table-column label="首重金额" prop="first_amount" width="120" align="center" />
          <el-table-column label="续重金额" prop="second_amount" width="120" align="center" />
          <el-table-column label="最大金额" prop="max_amount" width="120" align="center" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            fixed="right"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handlePcDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加运费' : '编辑运费'"
          :visible.sync="pcDialogVisible"
          width="600px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="120px"
          >
            <el-form-item label="运费类型" prop="type">
              <el-radio-group v-model="pcForm.type" @change="handleTypeChange">
                <el-radio :label="1">普通运费</el-radio>
                <el-radio :label="2">指定区域</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="选择区域" prop="area_name" v-if="pcForm.type == 2">
              <el-select
                v-model="pcForm.area_name"
                placeholder="请选择区域"
                style="width: 300px"
                clearable
              >
                <el-option
                  v-for="item in areasData"
                  :key="item.area_no"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="首重金额" prop="first_amount">
              <el-input
                v-model.number="pcForm.first_amount"
                placeholder="请输入首重金额"
                style="width: 300px"
                type="number"
              />
            </el-form-item>

            <el-form-item label="续重金额" prop="second_amount">
              <el-input
                v-model.number="pcForm.second_amount"
                placeholder="请输入续重金额"
                style="width: 300px"
                type="number"
              />
            </el-form-item>

            <el-form-item label="最大金额" prop="max_amount">
              <el-input
                v-model.number="pcForm.max_amount"
                placeholder="请输入最大金额"
                style="width: 300px"
                type="number"
              />
            </el-form-item>
          </el-form>

          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加运费</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">
                  {{ item.type == 1 ? "普通运费" : item.area_name }}
                </div>
                <div class="meta">
                  ID:{{ item.id }} | 首重:¥{{ item.first_amount }}
                </div>
              </div>
              <div class="status" :class="item.type == 1 ? 'on' : 'off'">
                {{ item.type == 1 ? "普通" : "指定" }}
              </div>
            </div>
            <div class="card-body">
              <div>续重：¥{{ item.second_amount }}</div>
              <div>最大：¥{{ item.max_amount }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                plain
                round
                @click.stop="handleMobileDel(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
          />
        </div>

        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加运费' : '编辑运费'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="100px"
            size="small"
          >
            <el-form-item label="运费类型" prop="type">
              <el-radio-group v-model="mobileForm.type" @change="handleMobileTypeChange" size="mini">
                <el-radio :label="1">普通</el-radio>
                <el-radio :label="2">指定区域</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="选择区域" prop="area_name" v-if="mobileForm.type == 2">
              <el-select
                v-model="mobileForm.area_name"
                placeholder="请选择"
                size="medium"
                clearable
              >
                <el-option
                  v-for="item in areasData"
                  :key="item.area_no"
                  :label="item.name"
                  :value="item.name"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="首重金额" prop="first_amount">
              <el-input
                v-model.number="mobileForm.first_amount"
                placeholder="首重金额"
                size="medium"
                type="number"
              />
            </el-form-item>
            <el-form-item label="续重金额" prop="second_amount">
              <el-input
                v-model.number="mobileForm.second_amount"
                placeholder="续重金额"
                size="medium"
                type="number"
              />
            </el-form-item>
            <el-form-item label="最大金额" prop="max_amount">
              <el-input
                v-model.number="mobileForm.max_amount"
                placeholder="最大金额"
                size="medium"
                type="number"
              />
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="display: flex; justify-content: flex-end; gap: 10px"
          >
            <el-button size="medium" @click="mobileDialogVisible = false">取消</el-button>
            <el-button type="primary" size="medium" @click="mobileSubmitForm">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "ShopFreight",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: {
        page: 1,
        page_size: 10,
      },
      // 地区选择数据
      areasData: [],

      // 表单验证
      addRules: {
        type: [{ required: true, message: "请选择运费类型", trigger: "change" }],
        area_name: [
          { required: true, message: "请选择区域", trigger: "change" },
        ],
        first_amount: [
          { required: true, message: "请输入首重金额", trigger: "blur" },
        ],
        second_amount: [
          { required: true, message: "请输入续重金额", trigger: "blur" },
        ],
        max_amount: [
          { required: true, message: "请输入最大金额", trigger: "blur" },
        ],
      },

      // PC
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        freight_id: "",
        type: 1,
        area_name: "",
        first_amount: "",
        second_amount: "",
        max_amount: "",
      },

      // 移动端
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        freight_id: "",
        type: 1,
        area_name: "",
        first_amount: "",
        second_amount: "",
        max_amount: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // ==================== 运费列表 ====================
    getList() {
      this.loading = true;
      api.areas
        .freightList({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
            this.areasData = res.data.data.areasData || [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== 删除 ====================
    handlePcDel(row) {
      this.$confirm("此操作将永久删除该运费配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteFreight(row.id);
      });
    },
    handleMobileDel(row) {
      this.$confirm("确认删除该运费配置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteFreight(row.id);
      });
    },
    deleteFreight(id) {
      this.loading = true;
      api.areas
        .del({ freight_id: id })
        .then((res) => {
          if (res.data.code == 1000) {
            this.getList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== PC ====================
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        freight_id: row.id,
        type: row.type,
        area_name: row.area_name || "",
        first_amount: row.first_amount,
        second_amount: row.second_amount,
        max_amount: row.max_amount,
      };
      this.pcDialogVisible = true;
    },
    pcResetForm() {
      this.pcForm = {
        freight_id: "",
        type: 1,
        area_name: "",
        first_amount: "",
        second_amount: "",
        max_amount: "",
      };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    handleTypeChange() {
      if (this.pcForm.type == 1) {
        this.pcForm.area_name = "";
      }
    },
    pcSubmitForm() {
      // 普通类型清空区域
      if (this.pcForm.type == 1) this.pcForm.area_name = "";

      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        const fn = this.pcDialogType == "add" ? api.areas.add : api.areas.edit;
        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 移动端 ====================
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        freight_id: row.id,
        type: row.type,
        area_name: row.area_name || "",
        first_amount: row.first_amount,
        second_amount: row.second_amount,
        max_amount: row.max_amount,
      };
      this.mobileDialogVisible = true;
    },
    mobileResetForm() {
      this.mobileForm = {
        freight_id: "",
        type: 1,
        area_name: "",
        first_amount: "",
        second_amount: "",
        max_amount: "",
      };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    handleMobileTypeChange() {
      if (this.mobileForm.type == 1) {
        this.mobileForm.area_name = "";
      }
    },
    mobileSubmitForm() {
      if (this.mobileForm.type == 1) this.mobileForm.area_name = "";

      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        const fn =
          this.mobileDialogType == "add" ? api.areas.add : api.areas.edit;
        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 公共 ====================
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ff;
  color: #1989fa;
}
.status.off {
  background: #fef0f0;
  color: #f56c6c;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/areas/freight.vue